// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"ee9d13a6","45":"b2d09abe","48":"83c9c245","273":"bef407b2","418":"94499f29","431":"0c253f4b","470":"f41cb7d8","520":"18ef7769","581":"f9289a8e","626":"b99747d9","778":"0077b2cb","857":"85d31835","954":"c8649004"}[chunkId] + ".chunk.js";
};